import httpClient from "../httpClient"

import { formatData } from "../request"
import { encodeRequestParameters } from "../request"

import { mobipassAccessoriesFormat } from "../formats"

export async function createMobipassAccessories(payload) {
    payload = formatData(mobipassAccessoriesFormat, payload)

    if (!payload) {
        throw "500"
    }

    return await httpClient
        .post("/mobipass", payload)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export async function updateMobipassAccessories(id, payload) {
    payload = formatData(mobipassAccessoriesFormat, payload)

    if (!payload) {
        throw "500"
    }

    return await httpClient
        .post(`/mobipass/${id}`, payload)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export async function moveMobipassAccessories(id, payload) {
    payload = formatData(mobipassAccessoriesFormat, payload)

    if (!payload) {
        throw "500"
    }

    return await httpClient
        .post(`/mobipass/${id}/move`, payload)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export async function deleteMobipassAccessories(id) {
    return await httpClient
        .delete(`/mobipass/${id}`)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}
